import * as React from "react";
import Svg, { Path } from "react-native-svg";
const WorkspacePremium = (props: any) => (
    <Svg
        width={16}
        height={21}
        viewBox="0 0 16 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <Path
            d="M5.8 11.4885L6.627 8.773L4.452 7.09625H7.15775L8 4.39225L8.84225 7.09625H11.548L9.35775 8.773L10.1845 11.4885L8 9.8L5.8 11.4885ZM2.5 20.2307V13.073C1.86667 12.4115 1.375 11.6468 1.025 10.7788C0.675 9.91092 0.5 8.98467 0.5 8C0.5 5.90767 1.22692 4.13458 2.68075 2.68075C4.13458 1.22692 5.90767 0.5 8 0.5C10.0923 0.5 11.8654 1.22692 13.3193 2.68075C14.7731 4.13458 15.5 5.90767 15.5 8C15.5 8.98467 15.325 9.91092 14.975 10.7788C14.625 11.6468 14.1333 12.4115 13.5 13.073V20.2307L8 18.4807L2.5 20.2307ZM8 14C9.66667 14 11.0833 13.4167 12.25 12.25C13.4167 11.0833 14 9.66667 14 8C14 6.33333 13.4167 4.91667 12.25 3.75C11.0833 2.58333 9.66667 2 8 2C6.33333 2 4.91667 2.58333 3.75 3.75C2.58333 4.91667 2 6.33333 2 8C2 9.66667 2.58333 11.0833 3.75 12.25C4.91667 13.4167 6.33333 14 8 14ZM4 18.0345L8 16.9615L12 18.0345V14.3193C11.4295 14.6911 10.8052 14.9808 10.127 15.1885C9.44867 15.3962 8.73967 15.5 8 15.5C7.26033 15.5 6.55133 15.3962 5.873 15.1885C5.19483 14.9808 4.5705 14.6911 4 14.3193V18.0345Z"
            fill={props.color ? props.color : '#1434CB'}
        />
    </Svg>
);
export default WorkspacePremium;
